import { useDispatch, useSelector } from "react-redux";
import { HIDE_SIDE_MENU_CONVERSATION } from "../../../redux/action/menu/side/sideType";
import { useEffect, useRef, useState } from "react";
import MessagesListBot from "../MainMenu/ListConverstion";
import LogoSide from "./LogoSide";

const SideMenuConversation = () => {
  const dispatch = useDispatch();
  const showMenuConversation = useSelector(
    (state) => state.menu.side.showMenuConversation
  );

  const [enableAnimation, setEnableAnimation] = useState(false);
  const [destroyMenu, setDestroyMenu] = useState(!enableAnimation);

  const navRef = useRef();

  useEffect(() => {
    if (showMenuConversation) {
      document.body.classList.add("modal-opened");

      setEnableAnimation(true);
      setDestroyMenu(false);

      // add animation to nav
      navRef.current.classList.add("duration-300");

      setTimeout(() => {
        // remove animation from nav
        navRef.current.classList.remove("duration-300");
      }, 300);
    } else {
      document.body.classList.remove("modal-opened");

      setEnableAnimation(false);

      // add animation to nav
      if (navRef.current) {
        navRef.current.classList.add("duration-300");
      }

      // after 300ml come destroyMenu
      setTimeout(() => {
        setDestroyMenu(true);

        if (navRef.current) {
          navRef.current.classList.remove("duration-300");
        }
      }, 300);
    }
  }, [showMenuConversation]);

  useEffect(() => {
    return () => {
      // come close the menu
      dispatch({
        type: HIDE_SIDE_MENU_CONVERSATION,
      });
    };
  }, []);

  const hideMenu = () => {
    dispatch({
      type: HIDE_SIDE_MENU_CONVERSATION,
    });
  };

  if (showMenuConversation || !destroyMenu) {
    return (
      <sectionƒ>
        <nav
          ref={navRef}
          className={`fixed top-0 lg:left-0 lg:right-auto right-0 ${
            !enableAnimation || destroyMenu
              ? "lg:-translate-x-full translate-x-full"
              : ""
          } duration-300 z-40 bg-white lg:w-80 3xm:w-72 w-64 h-full shadow-custom-md lg:p-4 lg:border-r lg:border-l-0 lg:border-gray-200 flex flex-col justify-between gap-4 select-none`}
        >
          <div className="mb-auto p-3">
            <LogoSide />
            <MessagesListBot />
          </div>
        </nav>

        {/* backdrop */}
        {showMenuConversation && (
          <div onClick={hideMenu} className="backdrop bg-black/70"></div>
        )}
      </sectionƒ>
    );
  }
};

export default SideMenuConversation;
